import type { SVGProps } from "react";
export interface OfficePhoneIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function OfficePhoneIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: OfficePhoneIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.866 7.808a1.875 1.875 0 0 0-1.675-1.673L19 6.125h-3.875V8c0 .483.392.874.874.875h4.876V8l-.01-.192ZM23.125 18A4.125 4.125 0 0 1 19 22.125H5A4.125 4.125 0 0 1 .875 18V8A4.125 4.125 0 0 1 5 3.875h.5l.115.006a1.125 1.125 0 0 1 0 2.238l-.115.006H5c-1.036 0-1.875.84-1.875 1.875v10c0 1.036.84 1.875 1.875 1.875h14c1.035 0 1.874-.84 1.875-1.875v-6.876h-4.876A3.125 3.125 0 0 1 12.875 8V6.125h-2.374a1.125 1.125 0 1 1 0-2.25H19l.421.022A4.124 4.124 0 0 1 23.125 8z"
      />
      <path
        fill={color}
        d="M9.375 4.5A.375.375 0 0 0 9 4.125H7a.375.375 0 0 0-.375.375V16c0 .207.168.375.375.375h2A.375.375 0 0 0 9.375 16zm10.5 12.5a1.375 1.375 0 0 1-2.743.14l-.007-.14.007-.141a1.375 1.375 0 0 1 1.368-1.234l.141.008c.693.07 1.233.655 1.234 1.367m0-3.5a1.375 1.375 0 0 1-2.743.14l-.007-.14.007-.14a1.376 1.376 0 0 1 1.368-1.236l.141.008c.693.07 1.234.656 1.234 1.368m-3.5 3.5a1.376 1.376 0 0 1-2.742.14l-.007-.14.007-.141A1.374 1.374 0 0 1 15 15.625l.14.008c.694.07 1.235.655 1.235 1.367m0-3.5a1.376 1.376 0 0 1-2.742.14l-.007-.14.007-.14A1.375 1.375 0 0 1 15 12.123l.14.008c.694.07 1.235.656 1.235 1.368Zm-4.75 2.5A2.625 2.625 0 0 1 9 18.625H7A2.625 2.625 0 0 1 4.375 16V4.5A2.625 2.625 0 0 1 7 1.875h2A2.625 2.625 0 0 1 11.624 4.5z"
      />
    </svg>
  );
}
